var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,13H2.8c-0.6,0-1-0.4-1-1V2.5c0-0.6,0.4-1,1-1H10c0.6,0,1,0.4,1,1V12C11,12.6,10.5,13,10,13z M3.8,11H9V3.5H3.8V11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,22.5h-7.1c-0.6,0-1-0.4-1-1V12c0-0.6,0.4-1,1-1h7.1c0.6,0,1,0.4,1,1v9.5C22.8,22.1,22.4,22.5,21.8,22.5z M15.7,20.5 h5.1V13h-5.1V20.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,8.3h-7.1c-0.6,0-1-0.4-1-1V2.5c0-0.6,0.4-1,1-1h7.1c0.6,0,1,0.4,1,1v4.7C22.8,7.8,22.4,8.3,21.8,8.3z M15.7,6.3h5.1 V3.5h-5.1V6.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10,22.5H2.8c-0.6,0-1-0.4-1-1v-4.7c0-0.6,0.4-1,1-1H10c0.6,0,1,0.4,1,1v4.7C11,22.1,10.5,22.5,10,22.5z M3.8,20.5H9v-2.7 H3.8V20.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/OverviewIcon.c61ccc7208e1241f448ed55010c59643.svg";
export { ForwardRef as ReactComponent };